import { createFileRoute } from '@tanstack/react-router'
import { ChannelPage } from '~/features/admin/channel-page'

export const Route = createFileRoute('/admin/channel')({
  component: ChannelPage,
})
